// src/utils/ads.ts
// AdSense lo carga index.html solo cuando ya existe __tcfapi (CMP de Google; ahora mismo no hay, asi que no carga) y
// deja el estado en window.__adsense: 'loading' | 'ready' | 'off'. Aqui no se
// hace ningun push hasta que el script ha cargado.

/** Pide un anuncio para el siguiente <ins class="adsbygoogle"> sin procesar. */
function push(): void {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch (e) {
    console.error("AdSense push error:", e);
  }
}

export const pushAd = () => {
  // Con 'loading' no se hace nada: al cargar AdSense se atienden los <ins>
  // que sigan en pantalla. Con 'off' (sin CMP o bloqueado) no hay anuncios.
  if (window.__adsense === 'ready') push();
};

if (typeof document !== 'undefined') {
  document.addEventListener('adsense-ready', () => {
    const pending = document.querySelectorAll('ins.adsbygoogle:not([data-adsbygoogle-status])').length;
    for (let i = 0; i < pending; i++) push();
  });
}

declare global {
  interface Window {
    adsbygoogle: any;
    __adsense?: 'loading' | 'ready' | 'off';
  }
}
